module.exports = __webpack_public_path__ + "media/02.81978125.mp3";